var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.65806 10.6425C8.09146 7.79638 12.3919 5.95681 14.5593 5.05438C20.683 2.48592 21.956 2.03471 22.7816 2C22.9537 2 23.3665 2.03471 23.6417 2.24296C23.8481 2.41651 23.9169 2.65947 23.9513 2.83301C23.9858 3.00656 24.0202 3.38835 23.9858 3.70073C23.6417 7.20633 22.2312 15.7794 21.4743 19.7015C21.1647 21.3675 20.5454 21.9229 19.9606 21.9923C18.6877 22.0964 17.69 21.1246 16.4514 20.3263C14.5249 19.042 13.424 18.2437 11.5318 16.9942C9.36438 15.5365 10.7749 14.7381 12.0134 13.4539C12.3231 13.1068 17.9996 7.93521 18.1028 7.44929C18.1028 7.37987 18.1372 7.17162 17.9996 7.06749C17.862 6.96337 17.69 6.99807 17.5523 7.03278C17.3459 7.06749 14.2496 9.15002 8.22908 13.2457C7.33459 13.8704 6.54332 14.1481 5.82085 14.1481C5.02958 14.1481 3.51584 13.6969 2.38053 13.3151C1.0044 12.8639 -0.0964997 12.6209 0.0067099 11.8573C0.0755163 11.4755 0.625967 11.059 1.65806 10.6425Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.44a4c287aa5e853fc1a73e1e53012e66.svg";
export { ForwardRef as ReactComponent };